import { BorrowAdminChangeInterestContainer } from "../../../containers/borrowSystem/Contact/BorrowAdminChangeInterestContainer";
export function BorrowAdminChangeInterestPage () {
    return(
       <BorrowAdminChangeInterestContainer/>
    )
}